import React from 'react';
import { EstimatedCostsSection } from './estimated-costs-section';

const CostEstimatesTabContent = () => {
  return <EstimatedCostsSection />;
};

export { CostEstimatesTabContent };
